export const ROLES = {
  EAC_ADMIN: 'eac_admin',
  FH_ADMIN: 'fh_admin',
  USER: 'user',
};

export const TASK_MODULES = {
  IMMEDIATE: 'immediate',
  LEGAL: 'legal',
  MAIN: 'main',
  ASSET: 'asset',
  CLOSING: 'closing',
};

export const TASK_MODULE_LABEL_KEYS = {
  [TASK_MODULES.IMMEDIATE]: 'Immediate tasks',
  [TASK_MODULES.LEGAL]: 'Legal tasks',
  [TASK_MODULES.MAIN]: 'Main tasks',
  [TASK_MODULES.ASSET]: 'Assets tasks',
  [TASK_MODULES.CLOSING]: 'Closing tasks',
};

export const getTaskModuleLabelKey = (module) =>
  TASK_MODULE_LABEL_KEYS[module] ||
  TASK_MODULE_LABEL_KEYS[TASK_MODULES.IMMEDIATE];

export const TASK_STATUS = {
  NEW: 'new',
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  SUSPENDED: 'suspended',
  ON_HOLD: 'on_hold',
  DEACTIVATED: 'deactivated',
};

export const FIN_INSTITUTIONS = [
  'DecFinInstNameAssets',
  'DecFinInstNameLiability',
  'DecOthrFinLiability',
  'DecFinInstNameCreditCard',
  'DecOthrCreditCard',
];
export const FINAL_DISPOSITIONS = ['DecLiaFinalDisp', 'DecAssetFinalDisp'];
export const INTENDED_PLANS = [
  'DecLiaIntendedPlan',
  'DecNonFinIntendedPlan',
  'DecFinIntendedPlan',
];
export const ASSET_VALUES = ['DecLiabilityValues', 'DecAssetValues'];

export const CONTACT_US_URL = 'mailto:praedias@gmail.com';
export const TERMS_URL =
  'https://eac-public-files.s3.ca-central-1.amazonaws.com/EAC_Terms_and_Conditions.pdf';
export const PRIVACY_URL =
  'https://eac-public-files.s3.ca-central-1.amazonaws.com/EAC_Privacy_Policy.pdf';
